<template>
  <div class="index-page">
    <app-layout ovflowFlowMain="auto">
      <app-header slot="header">
        <header-right slot="right"></header-right>
      </app-header>
      <a-spin size="large" :spinning="isLoading">
      <div class="index-main" slot="default">
        <div class="banner">
          <a-carousel ref="carouselEle" :autoplaySpeed="autoplaySpeed" autoplay :class="['custom-carousel', `custom-carousel${carouselList.length}`]" dots-class="slick-dots slick-thumb">
            <div class="item" slot="customPaging" slot-scope="props">
              <div class="item-img" @click="goTo('/coursePlayer', getCarouselItem(props.i).id)" @mouseenter="changeCarousel(props.i)">
                <img :src="props.i | getCarouselImage(carouselList)">
              </div>
              <div class="item-text">
                <h6 :class="['title']" @click="goTo('/coursePlayer', getCarouselItem(props.i).id)" @mouseenter="changeCarousel(props.i)">{{getCarouselItem(props.i).title}}</h6>
                <div class="time">
                  <div class="time-img">
                    <img src="../assets/images/index/top_video@1x.png">
                  </div>
                  <span>{{getCarouselItem(props.i).time | transformSecond}}分钟</span>
                </div>
              </div>
            </div>
            <div class="custom-carousel__item" v-for="(item, index) in carouselList" :key="index">
              <img class="custom-carousel__item__img" :src="item.bannner" alt="" @click="goTo('/coursePlayer', item.id)">
            </div>
          </a-carousel>
        </div>
        <div class="index-bg">
          <div class="content">
            <div class="content-left">
              <div class="content-left--header">
                <div class="course-list-title">
                  <span class="title">全部课程</span>
                </div>
                <div class="search-box">
                  <a-select v-model="searchType" :getPopupContainer="triggerNode => triggerNode.parentNode">
                    <a-select-option v-for="item in searchTypeOptions" :key="item.value" :value="item.value">
                      {{item.label}}
                    </a-select-option>
                  </a-select>
                  <a-range-picker class="test" :locale="locale" :getCalendarContainer="triggerNode => triggerNode.parentNode" separator="至" :placeholder="['开始时间', '结束时间']" @change="onSearchDateChange" />
                  <a-button class="custom-button" type="primary" @click="onSearchSubmit">
                    筛选
                  </a-button>
                  <a-button class="custom-button" type="primary" :icon="isSortByAsc ? 'sort-ascending' : 'sort-descending'" @click="onSort" :title="isSortByAsc ? '按时间升序' : '按时间降序'">
                  </a-button>
                </div>
              </div>
              <a-spin size="large" :spinning="mugenLoading">
              <div class="course-list" ref="courseList_warp" id="courseList_warp">
                <vue-scroll ref="vs" @handle-scroll="onScroll">
                  <div class="items-wrap">
                    <div class="item" v-for="(item, index) in courseList" :key="index">
                      <div class="item-img" @click="goTo('/coursePlayer', item.id)">
                        <img :src="`${item.img}`">
                      </div>
                      <div class="course-type-tag">{{item.typeName}}</div>
                      <div class="item-text">
                        <div class="title" @click="goTo('/coursePlayer', item.id)">
                          <div>
                            <div class="title-img" v-if="item.isNew">
                              <img src="../assets/images/index/new_tag@1x.png">
                            </div>
                            <span>{{item.title}}</span>
                          </div>

                          <h6>{{item.date}}</h6>
                        </div>
                        <div class="videoTime">
                          <div class="left">
                            <div class="time-img">
                              <img src="../assets/images/index/video@1x.png">
                            </div>
                            <span>{{item.videoTime | transformSecond}}分钟</span>
                          </div>
                          <div class="right" v-if="item.watchedTime && item.videoTime">
                            <span class="watched" v-if="item.watchedTime >= item.videoTime">已看完</span>
                            <span class="watching" v-else>
                              已观看<span>{{item.watchedTime | transformSecond}}</span>分钟
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="watchedProgress" v-if="item.watchedTime" :style="{width:`${item.watchedTime / item.videoTime * 100}%`}"></div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
              </a-spin>
			  <div class="pageWrap">
				  <!-- 滚动分页改为点击分页 -->
				  <a-pagination v-model:current="megenPage" :defaultPageSize="pageSize" :total="megenPageTotal" show-less-items @change="changePage"/>
			  </div>
            </div>
            <div class="content-right">
              <div class="content-right--header">
                <div class="course-list-title">
                  <span class="title">时政新闻</span>
                </div>
                <a-button type="link" class="custom-button" @click="goTo('/newsList')">查看更多</a-button>
              </div>
             
             <div class="news-banner">
               <a-carousel autoplay arrows class="news-banner__carousel">
                  <div
                    slot="prevArrow"
                    class="custom-slick-arrow"
                    style="left: 10px;zIndex: 1"
                  >
                    <a-icon type="left-circle" />
                  </div>
                  <div slot="nextArrow" class="custom-slick-arrow" style="right: 10px">
                    <a-icon type="right-circle" />
                  </div>
                  <div class="item" v-for="(item, index) in newsBannerList" :key="index">
                    <div class="item-img" @click="goTo('/newDetail', item.id)">
                      <img :src="`${item.img}`">
                    </div>
                    <div class="title" @click="goTo('/newDetail', item.id)">{{item.title}}</div>
                  </div>
                </a-carousel>
              </div>
              <div class="news-list">
                <div class="item-wrap" v-for="(item, index) in newsList" :key="index">
                  <div class="item other">
                    <div class="title" @click="goTo('/newDetail', item.id)">{{item.title}}</div>
                    <div class="date">{{item.date}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </a-spin>
    </app-layout>
  </div>
</template>

<script>
import HeaderRight from '../components/layout/header-right.vue'
import { course, news, others } from '@/api'
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

export default {
  name: 'index',
  components: { HeaderRight },
  data () {
    return {
      locale,
      searchType: '',
      searchTypeOptions: [],
      newsList: [],
      courseList: [],
      carouselList: [],
      newsBannerList: [],
      isSortByAsc: false,
      mugenLoading: false,
      megenPage: 1,
      // 总页数
      megenPageTotal: 20,
      megenPagesize: 9,
      scrollTimeId: null,
      lastScrollTop: 0,
      startTime: '',
      endTime: '',
      isLoading: true,
      autoplaySpeed: 3000,
      pageSize: 9,
    }
  },
  filters: {
    transformSecond (second) {
      return Math.ceil(second / 60)
    },
    getCarouselImage (index, carouselList) {
      return (carouselList[index] || {}).img
    }
  },
  created () {
    Promise.all([this.getBannerSpeed(), this.getCarouselCourseList(), this.getNewsList(), this.getCourseCategory(), this.fetchData({}, 1)]).then(() => {
    }).catch(() => {
      this.$message.error('请求数据失败')
    }).finally(() => {
      this.isLoading = false
    })
  },
  mounted () {
  },
  methods: {
	changePage(page){
		this.megenPage = page
		this.fetchData({}, 1)
	},
    getBannerSpeed () {
       return others.bannerSpeed().then((res) => {
        let { data, status, msg = '' } = res || {}
        if (status !== 'success') {
          this.$message.error(msg)
          return res
        }

        this.autoplaySpeed = Number(data) * 1000
      })
    },
    changeCarousel (index) {
      this.$refs.carouselEle.goTo(index)
    },
    getCourseCategory () {
      return course.courseCategory().then((res) => {
        let { data = [], status, msg = '' } = res || {}
        if (status !== 'success') {
          this.$message.error(msg)
          return res
        }
        this.searchTypeOptions = data.map(item => {
          return {
            label: item.title,
            value: item.id
          }
        })
        this.searchTypeOptions.unshift({
          label: '全部类型',
          value: ''
        })
      })
    },
    onScroll () {
      if (this.scrollTimeId !== null) {
        clearTimeout(this.scrollTimeId)
      }
      this.scrollTimeId = setTimeout(this.handleScroll, 300)
    },
    handleScroll () {
		return
      const { v } = this.$refs['vs'].getScrollProcess()
      const { scrollTop } = this.$refs['vs'].getPosition()
      let delta = scrollTop - this.lastScrollTop

      if (v === 1 && delta > 0) {
        let params = {
          page: ++this.megenPage
        }
        this.fetchData(params)
      }

      this.lastScrollTop = scrollTop
    },
    fetchData (params = {}, flag) {
      // if (this.megenPage > this.megenPageTotal) {
      //   this.$message.info('已经到底了')
      //   return
      // }
      params = {
        page: this.megenPage,
        pageSize: this.megenPagesize,
        startTime: this.startTime,
        endTime: this.endTime,
        cid: this.searchType,
        sort: this.isSortByAsc ? 1 : 0,
        ...params
      }
      this.mugenLoading = true
      return course.list(params).then((res) => {
        let { data: { current_page, data, total, per_page }, status, msg = '' } = res || {}
        if (status !== 'success') {
          this.$message.error(msg)
          return res
        }
        if (flag === 1) {
          this.courseList = data
        } else {
			//去除滚动
			this.courseList = data
          // this.courseList = this.courseList.concat(data)
        }
        this.megenPage = current_page
        // this.megenPageTotal = Math.max(1, Math.ceil(total / per_page))
        this.megenPageTotal = total
        this.mugenLoading = false
      })
    },
    getNewsList () {
      return news.politicalNewsList().then((res) => {
        let { data = {}, status, msg = '' } = res || {}
        if (status !== 'success') {
          this.$message.error(msg)
          return res
        }
        this.newsList = data.list
        this.newsBannerList = data.first
      })
    },
    getCarouselItem (i) {
      return this.carouselList[i] || {}
    },
    getCarouselCourseList () {
      return course.carouselCourseList().then((res) => {
        let { data, status, msg = '' } = res || {}
        if (status !== 'success') {
          this.$message.error(msg)
          return res
        }

        this.carouselList = data
      })
    },
    goTo (path, id) {
      if (id == null) {
        this.$router.push(path)
      } else {
        this.$router.push({path, query: {id}})
      }
    },
    onSearchDateChange (val) {
      if (!val.length) {
        this.startTime = ''
        this.endTime = ''
      } else {
        this.startTime = val[0].format('YYYY-MM-DD')
        this.endTime = val[1].format('YYYY-MM-DD')
      }
    },
    onSearchSubmit () {
      this.megenPage = 1
      let params = {
        page: 1,
        pageSize: this.megenPagesize,
        startTime: this.startTime,
        endTime: this.endTime,
        cid: this.searchType
      }
      this.fetchData(params, 1)
    },
    onSort () {
      this.isSortByAsc = !this.isSortByAsc
      this.megenPage = 1
      let params = {
        page: 1,
        pageSize: this.megenPagesize,
        startTime: this.startTime,
        endTime: this.endTime,
        cid: this.searchType,
        sort: this.isSortByAsc ? 1 : 0
      }
      this.fetchData(params, 1)
    }
  }
}
</script>

<style lang="less" scoped>
@import "../assets/style/index";

  .index-page{
    .banner{
      width: 1920px;
      height: 400px;
    }
    .index-bg{
      font-family: 'SourceHanSansCN-Medium';
      .bgByMedia('/index/bg', 'png');
      min-height: 1079px;
      width: 1920px;
      background-size: 100% auto;
      background-repeat: no-repeat;
      padding-top: 28px;
      .content{
        width: 1400px;
        margin: 0 auto 0;
        border-top: 3px solid @hoverColor;
        padding: 35px 21px 55px 21px;
        display: flex;
        background-color: @contentBgColor;
        .course-list-title{
          position: relative;
          &::before{
            content: '';
            width: 20px;
            height: 20px;
            position: absolute;
            background-color: rgba(206, 35, 35, 0.6);
            border-radius: 50%;
          }
          .title{
            font-size: 22px;
            color: @titleColor;
            position: relative;
            z-index: 3;
          }
        }
        &-right{
          width: 344px;
          margin-left: 15px;
          &--header{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .custom-button{
              font-size: 14px;
              color: #FFFFFF;
              padding: 0;
            }
          }
          .news-banner{
            padding-top: 20px;
            .item{
              &-img{
                img{
                  width: 374px;
                  height: 267px;
                  cursor: pointer;
                }
              }
              position: relative;
              border-radius: 10px;
              overflow: hidden;
              .title{
                .ellipsis();
                position: absolute;
                bottom: 0;
                height: 50px;
                line-height: 50px;
                width: 374px;
                background-color: rgba(33, 33, 37, 0.7);
                padding: 0 5px;
                font-size: 14px;
                color: #fff;
                text-align: center;
                cursor: pointer;
              }
            }
          }
          .news-list{
            .item{
              &.other{
                padding: 20px 0 15px;
                border-bottom: 1px solid #40414C;/*no*/
                .title{
                  font-size: 14px;
                  color: @textColor;
                  margin-bottom: 15px;
                  .multiline-text-over(2);
                  &:hover{
                    color: @hoverColor;
                    text-decoration: underline;
                    cursor: pointer;
                  }
                }
                .date{
                  color: @dateColor;
                  font-size: 12px;
                }
              }
            }
          }
        }
        &-left{
          flex: 1;
          .content-left--header{
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .search-box{
            display: flex;
            flex:1;
            justify-content: flex-end;
            align-items: center;
			
            .custom-button{
              border-radius: 4px;
              background-color: @selectBgColor;
              border: 1px solid rgba(119, 119, 121, 1);/*no*/
            }
          }
          .course-list{
            overflow-y: auto;
            height: 855px;
            margin-top: 20px;
            .items-wrap{
              display: flex;
              flex-wrap: wrap;
            }
            .item{
              margin: 0px 20px 20px 0;
              width: 315px;
              height: 264px;
              background-color: @titleBgColor;
              border-radius: 6px;
              overflow: hidden;
              position: relative;
              // display: inline-block;
              &-img{
                img{
                  width: 100%;
                  height: 144px;
                  cursor: pointer;
                }
              }
              &-text{
                color: @textColor;
                .title{
                  font-size: 14px;
                  padding: 13px 15px 15px 15px;
                  border-bottom: 1px solid @lineColor; /*no*/
                  cursor: pointer;
                  &-img{
                    img{
                      width: 21px;
                      height: 18px;
                      margin-right: 6px;
                    }
                  }
                  div{
                    padding-bottom: 10px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    span{
                      flex: 1;
                      .ellipsis();
                    }
                  }
                  h6{
                    font-size: 12px;
                    color: @dateColor;
                    margin: 0;
                  }
                }
                .videoTime{
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  padding-right: 15px;
                  .left{
                    flex: 1;
                    font-size: 13px;
                    display: flex;
                    align-items: center;
                  }
                  .time-img{
                    img{
                      width: 42px;
                      height: 42px;
                    }
                  }
                  .right{
                    font-size: 12px;
                    color: @dateColor;
                    .watched{
                      color: @dateColor;
                    }
                    .watching{
                      span{
                        color: @hoverColor;
                        padding: 0 4px;
                      }
                    }
                  }
                }
              }
              .watchedProgress{
                height: 4px;
                background-color: @hoverColor;
                position: absolute;
                bottom: 0px; /*no*/
              }
              .course-type-tag{
                position: absolute;
                top: 15px;
                left: 0;
                background-color: #CE2323;
                color: #fff;
                font-size: 12px;
                max-width: 72px;
                padding: 0 6px;
                height: 20px;
                line-height: 20px;
                text-align: center;
                border-top-right-radius: 3px;
                border-bottom-right-radius: 3px;
                .text-over()
              }
            }
            .item:nth-child(3n+0) {
              margin-right: 0;
            }
          }
        }
      }
    }
  }
</style>
<style lang="less">
@import "../assets/style/index";

  .index-page{
    .banner{
      position: relative;
      .custom-carousel{
        position: absolute;
        width: 100%;
        height: 100%;
        overflow: hidden;
        .slick-slider, .slick-slider .slick-track, .slick-slider .slick-list, .slick-list .slick-slide > div{
          height: 100%;
        }
        &__item{
          height: 100%;
          &__img{
            width: 100%;
            height: 100%;
          }
        }
        .slick-dots-bottom{
          bottom: 30px;
        }
        .slick-thumb{
          width: 402px;
          height: 277px;
          border-radius: 8px;
          background-color: rgba(255, 255, 255, 0.7);
          box-shadow: 0px 5px 9px 0px rgba(149, 25, 25, 0.5);
          padding: 6px 20px 4px 20px;
          position: absolute;
          top: 71px;
          right: 115px;
          &::after{
            content: '';
            display: block;
            position: absolute;
            left: -10px;
            top: 40px;
            width:0;
            height:0;
            border-top:10px solid transparent;
            border-bottom:10px solid transparent;
            border-right:10px solid rgba(255, 255, 255, 0.7);
          }
          li {
            width: 100%;
            margin: 0;
            &.slick-active{
              .item-text{
                .title{
                  color: #CE2323;
                  font-size: 16px;
                }
              }
            }
          }
          .item{
            padding: 8px 0;
            border-bottom: 1px solid rgba(255, 255, 255, 1); /*no*/
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: nowrap;
            &:last-child{
              border: none;
            }
            &-img{
              width: 88px;
              &:hover{
                cursor: pointer;
              }
              img{
                width: 88px;
                height: 50px;
                margin-right: 12px;
              }
            }
            &-text{
              width: 263px;
              text-align: left;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              height: 50px;
              .title{
                font-size: 14px;
                color: #2C2C2C;
                margin-top: 2px;
                .ellipsis();
                &:hover{
                  cursor: pointer;
                }
              }
              .time{
                font-size: 12px;
                color:@dateColor;
                display: flex;
                align-items: center;
                margin-bottom: 3px;
                &-img{
                  margin-right: 5px;
                  img{
                    width: 14px;
                    height: 14px;
                  }
                }
              }
            }
          }
        }
      }
      .custom-carousel3{
        .slick-thumb li.slick-active .item-text .title{
          font-size: 20px;
        }
        .slick-thumb .item{
          padding: 14px 0;
        }
        .slick-thumb .item-img img{
          height: 59px;
        }
        .slick-thumb .item-text{
          height: 59px;
        }
        .slick-thumb .item-text .title{
          font-size: 16px;
        }
      }
      .custom-carousel4{
        .slick-thumb li.slick-active .item-text .title{
          font-size: 16px;
        }
        .slick-thumb .item{
          padding: 8px 0;
        }
        .slick-thumb .item-img img{
          height: 50px;
        }
        .slick-thumb .item-text{
          height: 50px;
        }
        .slick-thumb .item-text .title{
          font-size: 14px;
        }
      }
    }
    .index-bg{
      .search-box{
        .ant-select{
          color: #7e7e7e;
          .ant-select-selection{
            height: 30px;
            width: 115px;
          }
        }
        .ant-select-arrow{
          color: @selectTextColor;
        }
        .ant-calendar-picker{
          margin-left: 11px;
        }
        .ant-calendar-picker-input{
          color: #7e7e7e;
        }
        .ant-calendar-range-picker-separator{
          color: @selectTextColor;
        }
        .ant-select-selection, .ant-input, .ant-btn{
          border-radius: 4px;
          background-color: rgba(48, 49, 63, 1);
          border: 1px solid rgba(119, 119, 121, 1);/*no*/
        }
        .ant-btn{
          margin-left: 11px;
          color: #fff;
        }
      }
      .ant-calendar-picker:hover{
        .ant-calendar-picker-input:not(.ant-input-disabled){
          border-color:#999
        }
        .ant-calendar-picker-clear{
          background-color: transparent;
          color: #999;
        }
      }
    }
    .news-banner{
      .ant-carousel{
        .custom-slick-arrow {
          width: 25px;
          height: 25px;
          font-size: 25px;
          color: #fff;
          background-color: rgba(31, 45, 61, 0.11);
          opacity: 0;
        }
        .custom-slick-arrow:before {
          display: none;
        }
        .custom-slick-arrow:hover {
          opacity: 0.5;
        }
      }
      
    }
  }
  .index-page .index-bg .search-box .ant-select-selection, .index-page .index-bg .search-box .ant-input, .index-page .index-bg .search-box .ant-btn{
	  background-color: @selectBgColor !important;
	  color: @selectTextColor !important;
	  border: 0.00521rem solid @selectBorderColor !important;
  }
  .index-page .index-bg .search-box .ant-select{
	  color: @selectTextColor !important;
  }

  .pageWrap{
	  width: 100%;
	  display: flex;
	  justify-content: center;
  }
</style>